import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/space-grotesk/latin-400.css'
import '@fontsource/space-grotesk/latin-500.css'
import '@fontsource/space-grotesk/latin-600.css'
import '@fontsource/ibm-plex-mono/latin-400.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import './index.css'
import App from './App.jsx'
import { registerPwa } from './pwa'
import { APP_VERSION, updateDynamicFavicon } from './utils/operational'
import { experiencia } from './utils/api'

const preloadRecoveryKey = 'aden:preload-recovery'
const reportUnhandled = (type, error) => experiencia.telemetria({evento:'frontend_error',tela:location.pathname,contexto:{version:APP_VERSION,error_type:type||error?.name||'Error'}}).catch(()=>{})
window.addEventListener('error',event=>reportUnhandled(event.error?.name||'window_error',event.error))
window.addEventListener('unhandledrejection',event=>reportUnhandled(event.reason?.name||'unhandled_rejection',event.reason))
window.addEventListener('vite:preloadError', event => {
  event.preventDefault()
  const lastRecovery = Number(sessionStorage.getItem(preloadRecoveryKey) || 0)
  if (Date.now() - lastRecovery < 30000) return
  sessionStorage.setItem(preloadRecoveryKey, String(Date.now()))
  window.location.reload()
})
window.setTimeout(() => sessionStorage.removeItem(preloadRecoveryKey), 30000)

// Inicializa favicon dinâmico
fetch('/api/configuracao/publica')
  .then(r => r.ok ? r.json() : null)
  .then(d => {
    const timezone = d?.system_timezone || 'America/Sao_Paulo'
    globalThis.__ADEN_TIMEZONE__ = timezone
    localStorage.setItem('aden:system-timezone', timezone)
    updateDynamicFavicon(d?.favicon_svg || null)
  })
  .catch(() => {
    updateDynamicFavicon(null)
  })

const savedTheme = localStorage.getItem('theme')
const initialTheme = savedTheme || (matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark')
document.documentElement.dataset.theme = initialTheme
document.getElementById('app-theme-color')?.setAttribute('content', initialTheme === 'light' ? '#F5F5F7' : '#000000')
createRoot(document.getElementById('root')).render(<StrictMode><App/></StrictMode>)
registerPwa(registration => window.dispatchEvent(new CustomEvent('aden:pwa-update', { detail: registration })))
